export default {
      id: "chevron_date-usage",
      viewBox: "0 0 13 24",
      url: "../dist/images/" + "sprite.svg#chevron_date-usage",
      toString: function () {
        return this.url;
      }
    }